import { useEffect, useState } from 'react';
import { Form, Row, Col, InputGroup, Button, Card } from 'react-bootstrap';
import {
  useCreateTicketingRequest,
  useGetTicketServiceList,
} from '../apiEndpoints/VisitorApiEndpoints';
import Toaster from '../../../Components/Toaster/Toaster';
import { useNavigate, useNavigation } from 'react-router-dom';
const Toast = Toaster();
const CreateTicketingRequest = ({
  handleClose,
}: {
  handleClose?: () => void;
}) => {
  const navigate = useNavigate();
  const { data } = useGetTicketServiceList();
  const [total, setTotal] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const { mutate, isSuccess, data: ticketCreate } = useCreateTicketingRequest();
  const handleQuantityChange = (event: number) => {
    const qty = Math.max(0, event || 1) * Number(data?.data[0]?.amount);
    setTotal(qty);
    setQuantity(event);
  };

  useEffect(() => {
    if (data?.data) {
      setTotal(Number(data?.data[0]?.amount));
    }
  }, [data?.data]);
  useEffect(() => {
    if (isSuccess && ticketCreate) {
      handleClose?.();
      navigate(`/visitor/view-billing-info/${ticketCreate?.data?.invoice_id}`);
    }
  }, [isSuccess, ticketCreate]);
  const handleSubmit = () => {
    if (total) {
      mutate({ service_id: data?.data[0]?.id as number, quantity });
    } else {
      Toast.fire({
        icon: 'error',
        title: `Please add quantity`,
      });
    }
  };
  return (
    <Card className='p-3 shadow-sm'>
      <Card.Title className='text-center mb-4'>Ticketing Request</Card.Title>
      <Form>
        <Row className='mb-3'>
          <Col>
            <Form.Label>Per Ticket Price</Form.Label>
            <Form.Select disabled>
              {data?.data?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name} ({item.amount})
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col>
            <Form.Label>Quantity</Form.Label>
            <InputGroup>
              <Form.Control
                required
                type='number'
                min='0'
                defaultValue={1}
                onChange={(e) => handleQuantityChange(Number(e?.target?.value))}
              />
            </InputGroup>
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col>
            <h5 className='text-center'>
              Total: <span className='text-primary'>{total?.toFixed(2)}</span>
            </h5>
          </Col>
        </Row>
        <Row className='text-center'>
          <Col onClick={handleSubmit}>
            <Button variant='primary'>Submit Request</Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default CreateTicketingRequest;
